export function subscribeMessage(topic: string) {
  return `[5,"${topic}"]`;
}

export function unsubscribeMessage(topic: string) {
  return `[5,"${topic}", ${JSON.stringify({ action: "unsubscribe" })}]`;
}

export function randomID() {
  return Math.random().toString(16).slice(2);
}
